module.exports = __webpack_public_path__ + "img/97e4570.png";